export default "__VITE_ASSET__9wBpHf6e__"